import React from 'react';
import c from 'classnames';
import s from './InputSuccessMessage.scss';

interface Props {
  className?: string;
}

/**
 * A success message! Meant to follow an input field.
 */
const InputSuccessMessage: React.FC<React.PropsWithChildren<Props>> = ({ children, className }) => {
  return <span className={c(s['root'], className)}>{children}</span>;
};
InputSuccessMessage.displayName = 'InputSuccessMessage';

export default InputSuccessMessage;
